import { Mic as MicIcon, NoteAdd as NoteAddIcon } from '@mui/icons-material';
import compact from 'lodash/compact';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useActiveStation } from '../../../../core/stations/hooks/useActiveStation';
import { LoggerCursorMenuPlugin } from '../../../logger/screens/stream/components/focus/cursor/cursor-menu/CursorMenu';
import { isAuditEnabled } from '../../helpers';
import { useLiveMentionsEnabledForActiveStation } from '../../hooks/useLiveMentionsEnabledForActiveStation';
import { LiveMentionAddFromCursor } from './LiveMentionAddFromCursor';
import { MatchAddFromCursor } from './MatchAddFromCursor';

export function useAuditActionsForLoggerSelectionMenu(): LoggerCursorMenuPlugin {
  const { formatMessage } = useIntl();
  const [action, setAction] = useState<'match-add' | 'live-mention-add' | null>(null);
  const station = useActiveStation();
  const liveMentionsEnabled = useLiveMentionsEnabledForActiveStation();

  return {
    customActions: compact([
      isAuditEnabled(station)
        ? {
            icon: <NoteAddIcon fontSize="small" />,
            onClick: () => setAction('match-add'),
            tooltip: formatMessage({
              id: 'audit.matchesAdd.title',
              defaultMessage: 'Crear match manual',
            }),
          }
        : null,
      isAuditEnabled(station) && liveMentionsEnabled
        ? {
            icon: <MicIcon fontSize="small" />,
            onClick: () => setAction('live-mention-add'),
            tooltip: formatMessage({
              id: 'audit.liveMentionsAdd.title',
              defaultMessage: 'Crear mención manual',
            }),
          }
        : null,
    ]),
    components: (
      <>
        <MatchAddFromCursor show={action === 'match-add'} onHide={() => setAction(null)} />
        <LiveMentionAddFromCursor
          show={action === 'live-mention-add'}
          onHide={() => setAction(null)}
        />
      </>
    ),
  };
}
